import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CgpTreeviewService {

  constructor() { }

  private dataSource = new Subject<any>();
  private selected = new Subject<any>();

  data: any;
  dataItem: any;

  dataSource$ = this.dataSource.asObservable();
  selected$ = this.selected.asObservable();

  get() {
    return this.dataSource.next(this.data);
  }

  add(obj: any) {
    this.data = obj;
    this.dataSource.next(obj);
  }

  setSelected(obj: any) {
    this.dataItem = obj;
    this.selected.next(obj);
  }

  getSelected() {
    return this.selected.next(this.dataItem);
  }

  refresh() {
    let child = this.dataItem,
      parent = child.id.parent;
    parent.isChanged = true;
    this.selected.next(parent);
    parent.expanded = true;
    child.expanded = true;
    child.selected = true;
  }

}
